.root {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
}

.fieldColumn {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.rowGap16 {
  display: flex;
  flex-direction: row;
  gap: 16px;
}

.requirementRow {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
}

.chipMinWidth {
  min-width: 70px;
}

.noteMargin {
  margin-left: 80px;
}

.channelInput {
  width: 60px;
}

.roleInput {
  min-width: 150px;
}

.monitorInput {
  width: 60px;
}

.backlineChips {
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;
}

.addRow {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: flex-end;
}

.categorySelect {
  min-width: 120px;
}

.qtyInput {
  width: 70px;
}

.drinksChips {
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 8px;
}

.noDrinksText {
  margin-bottom: 8px;
}

.requirementItem {
  margin-bottom: 4px;
}

.flex1 {
  flex: 1;
}
